// extracted by mini-css-extract-plugin
module.exports = {"EnquireThanks":"EnquireThanks_EnquireThanks__IFRdq","animation":"EnquireThanks_animation__8AvWu","text":"EnquireThanks_text__TFDoU","completed":"EnquireThanks_completed__lAT7A"};